import isServer from './isServer';

const scrollIntoViewUtil = (targetSelector, timeOut = 500) => {
  if (isServer()) {
    return;
  }
  const targetElement = document.querySelector(targetSelector);
  setTimeout(() => {
    targetElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, timeOut);
};

export default scrollIntoViewUtil;
